import type { PostRepository } from '../repositories/post_repository'

export class DeletePostUseCase {
  constructor(private readonly repository: PostRepository) {}

  execute(id: string): Promise<void> {
    return this.repository.delete(id)
  }
}
